var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1562 12.2799C15.7331 13.5354 13.8437 14.306 11.7616 14.306C9.64853 14.306 7.72812 13.5104 6.29865 12.2177C2.97372 13.0878 0.916473 16.0586 0.916473 19.6074V21.416C0.916473 25.6485 22.2775 25.6485 22.2775 21.416V19.6074C22.2773 16.152 20.3259 13.2309 17.1562 12.2799ZM11.7616 13.0196C15.4471 13.0196 18.4428 10.1419 18.4428 6.58698C18.4428 3.03203 15.4533 0.148315 11.7616 0.148315C8.0823 0.148315 5.08676 3.03211 5.08676 6.58704C5.08676 10.1421 8.0823 13.0196 11.7616 13.0196V13.0196Z",
    fill: "#0185c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.37a3d0d30b49c4fdac48e348f87b278c.svg";
export { ForwardRef as ReactComponent };